import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../shared/components/base/base.component';
import {UserService} from '../shared/services/user.service';
import {Store} from '@ngrx/store';
import {AppState} from '../store/app.reducer';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css'],
})
export class AdminComponent extends BaseComponent implements OnInit {

  constructor(
      protected store: Store<AppState>,
      userService: UserService) {
    super(store);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }


}
